module.exports = __webpack_public_path__ + "img/timetable.750eb10b.png";